import React from 'react';
import { Alert, Divider } from 'antd';
import ReactMarkdown from 'react-markdown';

import ComboAnswer from '../ComboAnswer';

import defaultStyles from './style.less';

function QuestionDropDown({ question,
                            answer,
                            disabled,
                            mutating,
                            onSetAnswer,
                            showValidationMessage,
                            styles = {
                              step: defaultStyles.step,
                              descCombo: defaultStyles.descCombo
                            }
                          }) {
  if (!question)
    return null;

  const onCombo = (e) => {
    if (onSetAnswer) onSetAnswer(e);
  };

  const { task, comment } = question;

  return (
    <div className={styles.step}>
      <div className={styles.descCombo}>
        <ReactMarkdown
          key={question.slug}
          source={task}
          renderers={{
            link: props => {
              //add check if href has special format, otherwise return simple hyperlink
              const regcheck = /\?\d+\|.+/;
              if (!regcheck.test(decodeURI(props.href)))
                return <a href={props.href}>{props.children}</a>;

              return (<ComboAnswer
                {...props}
                onChange={onCombo}
                question={question}
                answer={answer}
                disabled={disabled}
                mutating={mutating}
              />);
            },
            paragraph:'div',
          }}
        />
				{ showValidationMessage ? <Alert type="error" message="You must fill all comboboxes" /> : null }
				{ disabled && (
						<>
							<Divider />
							<ReactMarkdown source={comment} />
						</>
					)
				}
			</div>
    </div>
  );
}

export default QuestionDropDown;
